import { Trans, useTranslation } from "react-i18next";

import { Box, Typography } from "@mui/material";

import { useStyles } from "./PasswordRecoveryPageStyles";

type PasswordRecoverySuccessProps = {
    email: string;
};

export const PasswordRecoverySuccess = ({ email }: PasswordRecoverySuccessProps) => {
    const { classes } = useStyles();
    const { t } = useTranslation(["pages"]);

    return (
        <Box className={classes.successContainer}>
            <i className={`fa-solid fa-envelope-circle-check ${classes.successIcon}`} />
            <Typography variant="h5">{t("pages:passwordRecoveryPage.success.title")}</Typography>
            <Typography>
                <Trans
                    ns="pages"
                    i18nKey="passwordRecoveryPage.success.description"
                    values={{ email }}
                    components={{ email: <strong /> }}
                />
            </Typography>
            <Typography className={classes.footerText}>{t("pages:passwordRecoveryPage.success.noEmail")}</Typography>
        </Box>
    );
};
